module.exports = __webpack_public_path__ + "img/youshi.061a5d61.png";